import { lazyInject } from '@intelingu/core/IoC/container';
import { UserStore } from '@intelingu/core/stores/UserStore';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { ConfirmEmailComponent } from '../index/ConfirmEmailComponent';

interface DisabledPageProps {
}

@observer export class DisabledPage extends Component<DisabledPageProps, any> {

    @lazyInject(UserStore) userStore: UserStore;

    render() {
        return <div className={'session-page'}>
            <ConfirmEmailComponent />
        </div>
    }

}
